import React, { FC, MouseEvent } from "react";
import { useNavigate } from "react-router-dom";
import { Breadcrumbs, Typography, Link, Box } from "@mui/material";

interface BreadcrumbProps {
    title?: string;
    items: {
        label: string;
        active?: boolean;
        onClick?: (event: MouseEvent<HTMLElement>) => void;
        url?: string;
        state?: any | null;
    }[];
}

const Breadcrumb: FC<BreadcrumbProps> = ({ title, items }) => {
    const navigate = useNavigate();

    return (
        <Box sx={{ mb: 1 }}>
            {title && (
                <Typography variant="h6" fontWeight="bold" sx={{ fontSize: "16px", mb: 1 }}>
                    {title}
                </Typography>
            )}
            <Breadcrumbs aria-label="breadcrumb" sx={{ fontSize: "13px" }}>
                {items.map((item, index) => {
                    const isLast = index === items.length - 1;

                    return isLast || item.active ? (
                        <Typography key={index} color="text.primary" fontWeight="bold" sx={{ fontSize: "13px" }}>
                            {item.label}
                        </Typography>
                    ) : (
                        <Link
                            key={index}
                            component="button"
                            variant="body2"
                            underline="none"
                            onClick={(event) => {
                                if (item.onClick) {
                                    item.onClick(event);
                                } else if (item.url) {
                                    navigate(item.url, { state: { estado: item.state } });
                                }
                            }}
                            sx={{
                                cursor: "pointer",
                                // color: "#00A58D", 
                                fontSize: "13px",
                                // fontWeight: "bold",
                                transition: "0.3s",
                                // "&:hover": { color: "#007A64" }, 
                            }}
                        >
                            {item.label}
                        </Link>
                    );
                })}
            </Breadcrumbs>
        </Box>
    );
};

export default Breadcrumb;
